export function initTheme() {
  const host = window.location.hostname.toLowerCase();
  const isAdmin = window.location.pathname.startsWith('/admin');
  const params = new URLSearchParams(window.location.search);
  const themeParam = params.get('theme');
  const isZhongqiu = !isAdmin && (
    themeParam === 'zhongqiu' ||
    host.startsWith('zq.') ||
    host === 'zq'
  );
  if (isZhongqiu) {
    document.documentElement.classList.add('theme-zhongqiu');
  }
  return isZhongqiu ? 'zhongqiu' : 'duanwu';
}

export function getTheme() {
  return document.documentElement.classList.contains('theme-zhongqiu') ? 'zhongqiu' : 'duanwu';
}

export function getSite() {
  return getTheme();
}
